"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeAssetDirection = exports.TradeAssetType = exports.TradeType = void 0;
var TradeType;
(function (TradeType) {
    TradeType["BID"] = "bid";
    TradeType["PUBLIC_NFT_ORDER"] = "public_nft_order";
    TradeType["PUBLIC_ITEM_ORDER"] = "public_item_order";
})(TradeType = exports.TradeType || (exports.TradeType = {}));
var TradeAssetType;
(function (TradeAssetType) {
    TradeAssetType[TradeAssetType["ERC20"] = 1] = "ERC20";
    TradeAssetType[TradeAssetType["USD_PEGGED_MANA"] = 2] = "USD_PEGGED_MANA";
    TradeAssetType[TradeAssetType["ERC721"] = 3] = "ERC721";
    TradeAssetType[TradeAssetType["COLLECTION_ITEM"] = 4] = "COLLECTION_ITEM";
})(TradeAssetType = exports.TradeAssetType || (exports.TradeAssetType = {}));
var TradeAssetDirection;
(function (TradeAssetDirection) {
    TradeAssetDirection["SENT"] = "sent";
    TradeAssetDirection["RECEIVED"] = "received";
})(TradeAssetDirection = exports.TradeAssetDirection || (exports.TradeAssetDirection = {}));
//# sourceMappingURL=trade.js.map